import './agenda-overzicht.scss';

class AgendaOverzicht {
	constructor( el ) {
		this.el          = el;
		this.nonce       = el.dataset.nonce;
		this.ajaxUrl     = el.dataset.ajaxUrl;
		this.today       = el.dataset.today;
		this.ctaUrl      = el.dataset.ctaUrl || '';
		this.slotLabels  = JSON.parse( el.dataset.slotLabels || '{}' );
		this.maanden     = JSON.parse( el.dataset.maanden    || '[]' );
		this.i18n        = JSON.parse( el.dataset.i18n       || '{}' );

		this.modelsEl        = el.querySelector( '.sb-agenda__models' );
		this.selectedEl      = el.querySelector( '.sb-agenda__selected' );
		this.thumbEl         = el.querySelector( '.sb-agenda__thumb' );
		this.selectedNameEl  = el.querySelector( '.sb-agenda__selected-name' );
		this.selectedDescEl  = el.querySelector( '.sb-agenda__selected-desc' );
		this.lastMinuteEl    = el.querySelector( '.sb-agenda__last-minute' );
		this.selectedSlotEl  = el.querySelector( '.sb-agenda__selected-slot' );
		this.calendarWrapEl  = el.querySelector( '.sb-agenda__calendar-wrap' );
		this.calendarEl      = el.querySelector( '.sb-agenda__calendar' );
		this.slotPickerEl    = el.querySelector( '.sb-agenda__slot-picker' );
		this.ctaEl           = el.querySelector( '.sb-agenda__cta' );
		this.ctaBtn          = el.querySelector( '.js-agendaCtaBtn' );

		if ( this.ctaUrl && this.ctaBtn ) {
			this.ctaBtn.addEventListener( 'click', () => {
				window.location.href = this.ctaUrl;
			} );
		}

		const todayDate     = new Date( this.today + 'T00:00:00' );
		this.baseYear       = todayDate.getFullYear();
		this.baseMonth      = todayDate.getMonth() + 1;

		this.selectedModelId = null;
		this.year            = null;
		this.month           = null;
		this.selectedDate    = null;
		this.selectedSlot    = null;
		this.cache           = new Map();
		this.daySlots        = new Map();
		this.slotStatesByDate = new Map();

		el.querySelectorAll( '.js-agendaModelBtn' ).forEach( btn => {
			if ( btn.dataset.restricted ) return;
			btn.addEventListener( 'click', () => this.selectModel( btn ) );
		} );
	}

	selectModel( btn ) {
		const modelId    = btn.dataset.modelId;
		const name       = btn.dataset.modelName;
		const thumb      = btn.dataset.modelThumb;
		const desc       = btn.dataset.modelDesc || '';
		const lastMinute = !! btn.dataset.modelLastMinute;

		this.selectedModelId = modelId;
		this.year            = this.baseYear;
		this.month           = this.baseMonth;
		this.selectedDate    = null;
		this.selectedSlot    = null;
		this.cache.clear();
		this.daySlots        = new Map();
		this.slotStatesByDate = new Map();

		this.modelsEl.querySelectorAll( '.js-agendaModelBtn' ).forEach( b => {
			b.classList.toggle( 'sb-agenda__model-btn--active', b === btn );
		} );

		if ( thumb ) {
			this.thumbEl.src    = thumb;
			this.thumbEl.alt    = name;
			this.thumbEl.hidden = false;
		} else {
			this.thumbEl.hidden = true;
		}
		this.selectedNameEl.textContent = name;
		if ( this.selectedDescEl ) {
			this.selectedDescEl.textContent = desc;
			this.selectedDescEl.hidden      = ! desc;
		}
		if ( this.lastMinuteEl ) {
			this.lastMinuteEl.hidden = ! lastMinute;
		}
		this.selectedEl.hidden = false;

		this.calendarWrapEl.hidden      = false;
		this.slotPickerEl.hidden        = true;
		this.slotPickerEl.innerHTML     = '';
		this.ctaEl.hidden               = true;
		if ( this.selectedSlotEl ) this.selectedSlotEl.hidden = true;

		this.fetchAndRender( this.year, this.month );
	}

	async fetchAndRender( year, month ) {
		this.showLoading();

		const key = `${ year }-${ String( month ).padStart( 2, '0' ) }`;

		let data;
		if ( this.cache.has( key ) ) {
			data = this.cache.get( key );
		} else {
			const body = new FormData();
			body.append( 'action',  'sb_get_model_month_availability' );
			body.append( 'nonce',   this.nonce );
			body.append( 'post_id', this.selectedModelId );
			body.append( 'year',    year );
			body.append( 'month',   month );

			try {
				const res  = await fetch( this.ajaxUrl, { method: 'POST', body } );
				const json = await res.json();
				if ( ! json.success ) {
					this.showError();
					return;
				}
				data = json.data;
				this.cache.set( key, data );
			} catch {
				this.showError();
				return;
			}
		}

		this.year         = year;
		this.month        = month;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.renderCalendar( data );
		this.slotPickerEl.hidden    = true;
		this.slotPickerEl.innerHTML = '';
		this.ctaEl.hidden           = true;
	}

	renderCalendar( data ) {
		const { availability, slotsByDate = {}, hasPrevMonth, hasNextMonth, blockedDates = [] } = data;
		const monthLabel = this.maanden[ this.month - 1 ] || '';
		const blocked    = new Set( blockedDates );

		this.daySlots = new Map( Object.entries( availability ) );
		this.slotStatesByDate = new Map( Object.entries( slotsByDate ) );

		const firstDay    = new Date( this.year, this.month - 1, 1 );
		const daysInMonth = new Date( this.year, this.month, 0 ).getDate();

		let firstDow = firstDay.getDay();
		firstDow     = firstDow === 0 ? 7 : firstDow;
		const offset = firstDow - 1;

		const weekdagen = this.i18n.weekdagen || [ 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo' ];

		let html = `
			<div class="sb-agenda__nav">
				<button
					type="button"
					class="sb-agenda__nav-btn js-prevMonth"
					${ ! hasPrevMonth ? 'disabled aria-disabled="true"' : '' }
					aria-label="${ this.i18n.vorige_maand || 'Vorige maand' }"
				>&#8592;</button>
				<span class="sb-agenda__nav-title">${ monthLabel } ${ this.year }</span>
				<button
					type="button"
					class="sb-agenda__nav-btn js-nextMonth"
					${ ! hasNextMonth ? 'disabled aria-disabled="true"' : '' }
					aria-label="${ this.i18n.volgende_maand || 'Volgende maand' }"
				>&#8594;</button>
			</div>
			<div class="sb-agenda__grid" role="grid" aria-label="${ monthLabel } ${ this.year }">
				${ weekdagen.map( d => `<div class="sb-agenda__weekday" role="columnheader">${ d }</div>` ).join( '' ) }
		`;

		for ( let i = 0; i < offset; i++ ) {
			html += '<div class="sb-agenda__day sb-agenda__day--empty" role="gridcell" aria-hidden="true"></div>';
		}

		for ( let d = 1; d <= daysInMonth; d++ ) {
			const dateStr    = `${ this.year }-${ String( this.month ).padStart( 2, '0' ) }-${ String( d ).padStart( 2, '0' ) }`;
			const isBlocked  = blocked.has( dateStr );
			const isToday    = dateStr === this.today;
			const isPast     = dateStr < this.today;
			const isAvail    = ! isBlocked && ! isPast && this.daySlots.has( dateStr );
			const isSelected = dateStr === this.selectedDate;

			let cls = 'sb-agenda__day';
			if ( isBlocked )     cls += ' sb-agenda__day--blocked';
			else if ( isAvail )  cls += ' sb-agenda__day--available';
			else                 cls += ' sb-agenda__day--disabled';
			if ( isToday )       cls += ' sb-agenda__day--today';
			if ( isSelected )    cls += ' sb-agenda__day--selected';

			if ( isAvail ) {
				html += `<div class="${ cls }" data-date="${ dateStr }" tabindex="0" role="button" aria-label="${ d } ${ monthLabel }"${ isSelected ? ' aria-pressed="true"' : '' }>${ d }</div>`;
			} else {
				html += `<div class="${ cls }" role="gridcell" aria-label="${ d } ${ monthLabel }" aria-disabled="true"${ isBlocked ? ` title="${ this.i18n.gesloten_dag || 'Gesloten dag' }"` : '' }>${ d }</div>`;
			}
		}

		html += '</div>';
		this.calendarEl.innerHTML = html;

		const prevBtn = this.calendarEl.querySelector( '.js-prevMonth' );
		const nextBtn = this.calendarEl.querySelector( '.js-nextMonth' );
		if ( prevBtn ) prevBtn.addEventListener( 'click', () => this.goToPrevMonth() );
		if ( nextBtn ) nextBtn.addEventListener( 'click', () => this.goToNextMonth() );

		this.calendarEl.querySelectorAll( '.sb-agenda__day--available' ).forEach( cell => {
			cell.addEventListener( 'click', () => this.onDayClick( cell.dataset.date ) );
			cell.addEventListener( 'keydown', e => {
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					this.onDayClick( cell.dataset.date );
				}
			} );
		} );
	}

	onDayClick( date ) {
		this.selectedDate = date;
		this.selectedSlot = null;
		this.ctaEl.hidden = true;
		if ( this.selectedSlotEl ) this.selectedSlotEl.hidden = true;

		this.calendarEl.querySelectorAll( '.sb-agenda__day' ).forEach( c => {
			const sel = c.dataset.date === date;
			c.classList.toggle( 'sb-agenda__day--selected', sel );
			if ( c.hasAttribute( 'aria-pressed' ) ) {
				c.setAttribute( 'aria-pressed', sel ? 'true' : 'false' );
			}
		} );

		const slotStates = this.slotStatesByDate.get( date ) || [];
		this.renderSlotPicker( date, slotStates );
	}

	renderSlotPicker( date, slotStates ) {
		const [ , month, day ] = date.split( '-' );
		const monthLabel = this.maanden[ parseInt( month, 10 ) - 1 ] || '';
		const dayNum     = parseInt( day, 10 );

		let html = `
			<p class="sb-agenda__slot-title">
				${ this.i18n.dagdelen_op || 'Beschikbare dagdelen op' } <strong>${ dayNum } ${ monthLabel }</strong>
			</p>
			<div class="sb-agenda__slot-list">
		`;

		slotStates.forEach( slotState => {
			const slot = slotState?.slot || '';
			if ( ! slot ) {
				return;
			}
			const timeLabel = slotState?.label || this.slotLabels[ slot ] || slot;
			const disabled = slotState?.disabled === true;
			html += `
				<button type="button" class="sb-agenda__slot-btn js-slotBtn" data-slot="${ slot }" data-date="${ date }" ${ disabled ? 'disabled aria-disabled="true"' : '' }>
					<span class="sb-agenda__slot-code">${ slot }</span>
					<span class="sb-agenda__slot-time">${ timeLabel }</span>
				</button>
			`;
		} );

		html += '</div>';
		this.slotPickerEl.innerHTML = html;
		this.slotPickerEl.hidden    = false;

		this.slotPickerEl.querySelectorAll( '.js-slotBtn' ).forEach( btn => {
			if ( btn.disabled ) {
				return;
			}
			btn.addEventListener( 'click', () => this.onSlotClick( btn.dataset.date, btn.dataset.slot, btn ) );
		} );

		this.slotPickerEl.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
	}

	onSlotClick( date, slot, btn ) {
		this.selectedSlot = slot;

		this.slotPickerEl.querySelectorAll( '.js-slotBtn' ).forEach( b => {
			b.classList.toggle( 'sb-agenda__slot-btn--selected', b === btn );
			b.setAttribute( 'aria-pressed', b === btn ? 'true' : 'false' );
		} );

		const [ , month, day ] = date.split( '-' );
		const monthLabel = this.maanden[ parseInt( month, 10 ) - 1 ] || '';
		const dayNum     = parseInt( day, 10 );
		const timeLabel  = this.slotLabels[ slot ] || slot;
		const vraagTekst = `${ this.i18n.vraag_naar || 'Vraag naar beschikbaarheid op' } ${ dayNum } ${ monthLabel } (${ timeLabel })`;

		if ( this.selectedSlotEl ) {
			this.selectedSlotEl.textContent = vraagTekst;
			this.selectedSlotEl.hidden      = false;
		}

		this.ctaBtn.dataset.modelId = this.selectedModelId;
		this.ctaBtn.dataset.date   = date;
		this.ctaBtn.dataset.slot   = slot;

		this.ctaEl.hidden = false;
		this.ctaEl.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
	}

	goToPrevMonth() {
		let m = this.month - 1;
		let y = this.year;
		if ( m < 1 ) { m = 12; y--; }
		this.fetchAndRender( y, m );
	}

	goToNextMonth() {
		let m = this.month + 1;
		let y = this.year;
		if ( m > 12 ) { m = 1; y++; }
		this.fetchAndRender( y, m );
	}

	showLoading() {
		this.calendarEl.innerHTML = `<div class="sb-agenda__state">${ this.i18n.laden || 'Laden…' }</div>`;
	}

	showError() {
		this.calendarEl.innerHTML = `<div class="sb-agenda__state sb-agenda__state--error">${ this.i18n.fout || 'Er is een fout opgetreden.' }</div>`;
	}
}

document.querySelectorAll( '.js-agendaOverzicht' ).forEach( el => new AgendaOverzicht( el ) );
